import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const Intro = () => {
  return (
    <div className={cx('wrap')}>
      <div className={cx('desc')}>
        <span className={cx('period')}>이벤트 기간</span>
        <span className={cx('date', 'part')}>2024.06.01(토) ~ 2024.06.28(금)</span>
        <span className={cx('period')}>혜택 지급</span>
        <span className={cx('date')}>이벤트 종료 후 7일 이내</span>
      </div>
    </div>
  );
};

export default Intro;
